import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ILogSource, ILogsReducer } from '../../types/logs'
import { fetchLiveLogs } from '../async-thunks/logs/fetchLiveLogs'
import { downloadServerLogs } from '../async-thunks/logs/downloadServerLogs'
import { fetchProductLogs } from '../async-thunks/logs/fetchProductLogs'
import { downloadProductLogs } from '../async-thunks/logs/downloadProductLogs'
import { fetchLogSources } from '../async-thunks/logs/fetchLogSources'
import { fetchServerLogSources } from '../async-thunks/logs/fetchServerLogSources'

const initialState: ILogsReducer = {
    productsLiveLogs: {},
    logSources: {},
    serverLogSources: [],
    productLogs: [],
    isLoading: false,
}

const logsSlice = createSlice({
    name: 'logsSlice',
    initialState,
    reducers: {
        newLiveLog: (
            state,
            action: PayloadAction<{
                productGuid: string
                liveLogs: any[]
            }>
        ) => {
            const { productGuid, liveLogs } = action.payload
            state.productsLiveLogs[productGuid] = [
                ...(state.productsLiveLogs[productGuid] || []),
                ...liveLogs,
            ]
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchLiveLogs.pending, state => {
                state.isLoading = true
            })
            .addCase(fetchLiveLogs.fulfilled, (state, action: PayloadAction<{
                productGuid: string
                logsBatch: any[]
            }>) => {
                const { productGuid, logsBatch } = action.payload
                state.isLoading = false
                state.productsLiveLogs[productGuid] = logsBatch
            })
            .addCase(fetchLiveLogs.rejected, state => {
                state.isLoading = false
            })
            .addCase(downloadServerLogs.pending, state => {
                state.isLoading = true
            })
            .addCase(downloadServerLogs.fulfilled, (state) => {
                state.isLoading = false
            })
            .addCase(downloadServerLogs.rejected, state => {
                state.isLoading = false
            })
            .addCase(fetchLogSources.fulfilled, (state, action) => {
                state.isLoading = false
                if (action.payload) {
                    state.logSources[action.payload.productGuid] = action.payload.logSources
                }
            })
            .addCase(fetchServerLogSources.fulfilled, (state, action: PayloadAction<ILogSource[]>) => {
                state.serverLogSources = action.payload
            })
            .addCase(fetchProductLogs.fulfilled, (state, action: PayloadAction<any[]>) => {
                state.isLoading = false
                state.productLogs = action.payload
            })
            .addCase(downloadProductLogs.fulfilled, (state) => {
                state.isLoading = false
            })
    }
})

export const { actions: logsActions } = logsSlice
export const { reducer: logsReducer } = logsSlice
